import React from 'react'

import Show from './show/show'

import { Switch, Route, Redirect } from 'react-router-dom'

import { LAYOUT_MANAGER_USER_SHOW } from '../navigation'

const Router = () => (
  <Switch>
    <Route path={LAYOUT_MANAGER_USER_SHOW}>
      <Show />
    </Route>
    <Redirect to={LAYOUT_MANAGER_USER_SHOW} />
  </Switch>
)

export default Router
